/* eslint-disable valid-jsdoc, no-unused-vars */
import { IReplacementStrategy, ITimeAwareCache } from '../types';

/**
 * The base cache replacement strategy.
 */
export class ReplacementStrategy<TValue = unknown> implements IReplacementStrategy<TValue> {
  /**
   * Get the key of the cache entry to replace
   * @param {ITimeAwareCache} cache - The cache to write with
   * @param {string} key - The key for the new cache entry
   * @param {number} timestamp - The timestamp of the write operation
   * @returns {string | null} - The key of the entry to replace
   */
  keyToReplace(_cache: ITimeAwareCache<TValue>, _key: string, _timestamp: number): string | null {
    return null;
  }

  /**
   * Initialize the data structure to apply the strategy on a given cache
   * @param {ITimeAwareCache} cache - The cache to work with
   * @returns {void}
   */
  initializeCache(cache: ITimeAwareCache<TValue>): void {
    // Using the merged ITimeAwareCache definition which includes the subscribe method
    cache.subscribe(this);
  }
}
